<template>
  <div>
    <FormKit
      type="hidden"
      :name="`components[${index}][component_type]`"
      :value="component.component_type"
    />

    <FormKit
      label="Titel"
      type="text"
      :name="`components[${index}][title]`"
      :value="component.title"
      @input="(value) => update('title', value)"
    />

    <FormKit
      label="Eyebrow"
      type="text"
      :name="`components[${index}][eyebrow]`"
      :value="component.eyebrow"
      @input="(value) => update('eyebrow', value)"
    />

    <FormKit
      label="Achtergrond Kleur"
      type="text"
      :name="`components[${index}][background_color]`"
      :value="component.background_color"
      @input="(value) => update('background_color', value)"
    />

    <label class="formkit-label">Featured image</label>
    <FormKitImage
      :name="`components[${index}][background_image]`"
      :value="component.background_image"
      @input="(value) => update('background_image', value)"
    />

    <FormKit
      label="Achtergrond Opacity"
      type="number"
      :name="`components[${index}][background_image_opacity]`"
      :value="component.background_image_opacity ?? 0"
      @input="(value) => update('background_image_opacity', value)"
      validation="min:0|max:100"
    />

    <label class="formkit-label">Thumbnail</label>
    <FormKitImage
      :name="`components[${index}][thumbnail_image]`"
      :value="component.thumbnail_image"
      @input="(value) => update('thumbnail_image', value)"
    />

    <FormKit
      label="Thumbnail Opacity"
      type="number"
      :name="`components[${index}][thumbnail_image_opacity]`"
      :value="component.thumbnail_image_opacity ?? 0"
      @input="(value) => update('thumbnail_image_opacity', value)"
      validation="min:0|max:100"
    />
  </div>
</template>

<script>
import mixin from "../mixins/component";

export default {
  name: "PageSearchHero",
  mixins: [mixin],
};
</script>
